import { lazyRenderWidgetByLoader, projectLoaders } from 'core-components/helpers/lazyLoad'
import { IWidgetProps } from 'core-components/sitebuilder/models/IWidgetProps'
import { TAppWidget } from 'core-components/sitebuilder/models/IWidgetSelector'

interface ICoreWidgets {
  viewModel: string
  props: IWidgetProps
  AppWidgets: TAppWidget
  lazyWidgets: { [key: string]: TAppWidget }
}

// TODO CHECK AFTER MF
if (!projectLoaders['src/core/']) {
  projectLoaders['src/core/'] = (name: string) => {
    const layoutName = name.split('/').at(-1)

    if (layoutName === 'BaseLayout') {
      return import('src/core/layout/BaseLayout')
    }

    if (layoutName === 'LayoutClean') {
      return import('src/core/layout/LayoutClean')
    }

    if (
      name === 'src/core/sitebuilder/layout/settings/basicSettings/widgetLibrary/table/SourceEditor'
    ) {
      return import(
        'src/core/sitebuilder/layout/settings/basicSettings/widgetLibrary/table/SourceEditor'
      )
    }

    return import(/* @vite-ignore */ `src/core/layout/${layoutName}.tsx`)
  }
}

// TODO CHECK AFTER MF
// @ts-ignore TODO: Move to core-components?
if (!projectLoaders['core-components/']) {
  // @ts-ignore
  projectLoaders['core-components/'] = (name: string) => {
    const componentModules = import.meta.glob('core-components/sitebuilder/propertygenerator/**')
    const keys = Object.keys(componentModules)
    for (const key of keys) {
      if (key.replaceAll('src/', '').includes(name) && !key.endsWith('.scss')) {
        return componentModules[key]()
      }
    }
    return import('core-components/sitebuilder/layout/widgetCreator/EmptyWidget')
  }
}

export const CoreWidgets = ({ viewModel, props, AppWidgets, lazyWidgets }: ICoreWidgets) => {
  switch (viewModel) {
    case 'WidgetWidgetsList':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/WidgetsList'),
        props,
      })
    case 'WidgetSitePagesTree':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/SitePagesTree'),
        props,
      })
    case 'WidgetSitePagesDetail':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/SitePagesDetail'),
        props,
      })
    case 'WidgetUserList':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/user/UserList'),
        props,
      })
    case 'WidgetUserDetail':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/user/UserDetail'),
        props,
      })
    case 'WidgetSitePageRoles':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/user/SitePageRoles'),
        props,
      })
    case 'WidgetUserSettings':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/user/UserSettings'),
        props,
        loadMeta: true,
      })
    case 'WidgetLogin':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/layout/Login'),
        props,
      })
    case 'WidgetSimulationSettings':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/user/SimulationSettings'),
        props,
      })
    case 'WidgetVersion':
    case 'version-api':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/Version'),
        props,
      })
    case 'WidgetCMS':
    case 'cms':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/CMS'),
        props: { ...props, viewModel },
        loadMeta: true,
      })
    case 'lov-dropdowns':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/LOVforDropdowns'),
        props,
      })
    case 'core-data-migration':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/DataMigration'),
        props,
      })
    case 'core-data-access':
      return lazyRenderWidgetByLoader({
        id: viewModel,
        loader: () => import('src/core/sitebuilder/widgets/dataAccess'),
        props,
      })
    default:
      return <AppWidgets viewModel={viewModel} props={props} lazyWidgets={lazyWidgets} />
  }
}
